import { useCountUp } from "./useCountUp";

interface CountUpProps {
  value: number | string;
  duration?: number;
}

export default function CountUp({ value, duration = 1500 }: CountUpProps) {
  const { displayCount, prefix, suffix, isNaNValue } = useCountUp({ value, duration });

  if (isNaNValue) {
    return <span>{value}</span>;
  }

  return <span>{prefix}{displayCount}{suffix}</span>;
}
